import script from "./menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./menu.vue?vue&type=script&setup=true&lang=ts"

import "./menu.vue?vue&type=style&index=0&id=354ec065&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-354ec065"]])

export default __exports__